import { Link } from 'react-router';
import { Icon } from '@/comp/icon/icon';
import { AppContext } from '@/context/AppContext';
import { affiliate_checkIsAllowToBookService } from '@/_helper/checkAccess';
import { useContext, useMemo } from 'react';
import InfoCard from '@/comp/ui/infoCard/infoCard';
import TravelTile from '@/comp/travelTile';
import tourGuideModal from '@/comp/overlayModal/tourGuide/tourGuideModal';

export const HelpOnspot = () => {
    const { bookingData } = useContext(AppContext);

    // affiliate → check is allow to book digitalTourGuide service
    let service = 'digitalTourGuide';

    const showDigitalTourGuideTile = useMemo(
        () => bookingData?.data?.allowDigitalTourGuide === true,
        [bookingData?.data]
    );
    const showOnSpotTile = useMemo(() => !!bookingData?.data?.allowedInteractions?.onSpot, [bookingData?.data]);

    if (!bookingData || (window.$affiliate && !affiliate_checkIsAllowToBookService(service).includes(service))) {
        return null;
    }
    const { data } = bookingData;
    const { tourGuideData } = data;

    return (
        <div className="tab-content-container">
            {window.$browserInfo.device === 'mobile' && <div className="modal-mobile-background-layer"></div>}
            <div className="tab-header">
                <h3>Hilfe vor Ort</h3>
                {window.$browserInfo.device === 'mobile' && (
                    <Link rel="noopener noreferrer" className="modal-close" to={'/'}>
                        <Icon name="close" ariaLabel="overlay schließen" />
                    </Link>
                )}
            </div>
            <div className="tab-content">
                {!showDigitalTourGuideTile && !showOnSpotTile && (
                    <InfoCard type="large">
                        <p>
                            Dieser Bereich steht erst während Ihrer Reise zur Verfügung. Bei Problemen oder Fragen vor
                            der Reise nutzen Sie bitte das{' '}
                            <a rel="noopener noreferrer" href={`${window.$website}/service/kontakt`} target="_blank">
                                Kontaktformular
                            </a>
                            .
                        </p>
                    </InfoCard>
                )}

                {(showDigitalTourGuideTile || showOnSpotTile) && (
                    <>
                        {showDigitalTourGuideTile && (
                            <TravelTile
                                name="tourguide"
                                icon="mobile"
                                headline={`Digitale Reiseleitung ${tourGuideData?.registered ? '' : 'aktivieren'}`}
                                description={
                                    tourGuideData?.registered
                                        ? 'Sie haben die Digitale Reiseleitung bereits aktiviert.'
                                        : 'Wir unterstützen Sie kostenlos per WhatsApp bei Fragen und Wünschen während Ihrer Reise.'
                                }
                                state={tourGuideData?.registered ? 'read-only' : 'show'}
                                link="digitale-reiseleitung"
                                linkType={tourGuideData?.registered ? 'modal' : 'internal'}
                                target="_blank">
                                {tourGuideData.registered && tourGuideModal(tourGuideData)}
                            </TravelTile>
                        )}
                        {showOnSpotTile && (
                            <TravelTile
                                name="onSpot"
                                icon="help"
                                headline="Hilfe vor Ort - Unterkunft"
                                description={`Mit Ihrer Unterkunft ist etwas nicht in Ordnung? Reichen Sie Ihre Beschwerde einfach hier ein.`}
                                state="show"
                                link="hilfe-vor-ort"
                                linkType="internal"
                                target="_blank"
                            />
                        )}
                    </>
                )}
            </div>
        </div>
    );
};
